import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { UserService } from '../../../services/user.service';
import { CyclistService } from '../../../services/cyclist.service';
import { BikeService } from '../../../services/bike.service';
import { PartnerService } from '../../../services/partner.service';
import { LookupService } from '../../../services/lookup.service';
import { AppConfig } from '../../../app.config';

import { OverlayPanel } from 'primeng/overlaypanel';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { HelpersService } from '../../../services/helpers.service';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cyclist',
  templateUrl: './cyclist.component.html',
  styleUrls: ['./cyclist.component.scss'],
})
export class CyclistComponent implements OnInit {
  @Input() user;
  @Input() partnerId;
  @Input() messageService: MessageService;
  @Output() update = new EventEmitter();
  @Input() nextCyclist;
  @Input() bikeSale;

  public UserForm: FormGroup;
  public genders: any = [
    { label: this.translate.instant('general.male'), value: 1 },
    { label: this.translate.instant('general.female'), value: 2 },
  ];
  public busy: boolean = false;
  public error: boolean = false;
  public errorMessage = '';
  public userExists: boolean = false;
  public userLinkedToPartner: boolean = false;
  public DefaultUnitOfMeasure = 1;
  public cyclists: any = [];

  constructor(
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    public userService: UserService,
    public helpersService: HelpersService,
    public cyclistService: CyclistService,
    public partnerService: PartnerService,
    public bikeService: BikeService,
    private lookupService: LookupService,
    public appConfig: AppConfig,
    private translate: TranslateService,
  ) {
    var partnerData = helpersService.getPartnerData();
    this.DefaultUnitOfMeasure =
      partnerData && partnerData.DefaultUnitOfMeasure
        ? partnerData.DefaultUnitOfMeasure
        : 1;
  }

  ngOnInit() {
    this.setupValidation();
  }

  setupValidation() {
    this.UserForm = this.fb.group({
      Name: new FormControl(
        this.user.Name,
        this.user && this.user.ID
          ? Validators.nullValidator
          : Validators.required,
      ),
      Surname: new FormControl(
        this.user.Surname,
        this.user && this.user.ID
          ? Validators.nullValidator
          : Validators.nullValidator,
      ),
      Email: new FormControl(
        this.user.Email,
        this.user && this.user.ID
          ? Validators.nullValidator
          : Validators.compose([Validators.nullValidator, Validators.email]),
      ),
      PhoneNumber: new FormControl(
        this.user.PhoneNumber,
        Validators.nullValidator,
      ),
    });

    if (this.user && this.user.ID) {
      this.disableControls();
    }
  }

  reloadControlData() {
    this.UserForm.controls['Email'].setValue(this.user.Email);
    this.UserForm.controls['Name'].setValue(this.user.Name);
    this.UserForm.controls['Surname'].setValue(this.user.Surname);
    this.UserForm.controls['PhoneNumber'].setValue(this.user.PhoneNumber);
  }

  disableControls() {
    this.UserForm.controls['Email'].disable();
    this.UserForm.controls['Name'].disable();
    this.UserForm.controls['Surname'].disable();
    this.UserForm.controls['PhoneNumber'].disable();
  }

  enableControls() {
    this.UserForm.controls['Email'].enable();
    this.UserForm.controls['Name'].enable();
    this.UserForm.controls['Surname'].enable();
    this.UserForm.controls['PhoneNumber'].enable();
  }

  /*selectUser(user) {
    console.log(user)
    if (user.value) {
      user = { ...user, ...user.value };
    }
    this.user = user;
    this.reloadControlData();
    this.disableControls();
    if (!this.bikeSale) {
      this.update.emit(this.user);
    }
  }*/

  selectUser(user) {
    console.log(user)
    if (user.value) {
      user = { ...user, ...user.value };
    }
    console.log(this.user)
    if (user.ID == 0) {
      this.cyclistService.linkCyclists(this.partnerId, user).subscribe(linkedUser => {
        console.log(linkedUser)
        user = linkedUser.Data[0];
        this.busy = false;
        this.user = linkedUser.Data[0];
        this.reloadControlData();
        this.busy = false;
        this.disableControls();
        if (!this.bikeSale) {
          this.update.emit(this.user);
        }
      });
    }
    else {
      this.user = user;
      this.reloadControlData();
      this.busy = false;      
      this.disableControls();
      if (!this.bikeSale) {
        this.update.emit(this.user);
      }
    }
  }

  next() {
    if(this.nextCyclist){
      this.nextCyclist(this.user);
    }
  }

  valid() {
    console.log((this.UserForm.controls['Email'].value &&
      this.UserForm.controls['Email'].value.length > 0) ||
    (this.UserForm.controls['PhoneNumber'].value &&
      this.UserForm.controls['PhoneNumber'].value.length > 0))
      console.log(this.UserForm.controls)
    return (
      (this.UserForm.controls['Email'].value &&
        this.UserForm.controls['Email'].value.length > 0) ||
      (this.UserForm.controls['PhoneNumber'].value &&
        this.UserForm.controls['PhoneNumber'].value.length > 0)
    );
  }

  /*searchEmail(event) {
    if (
      this.UserForm.controls['Email'].value.length > 0 &&
      this.UserForm.controls['Email'].value.indexOf('@') > -1
    ) {
      this.user = {};
      this.cyclistService
        .searchCyclistByEmail(0, this.UserForm.controls['Email'].value)
        .subscribe((cyclists) => {
          if (cyclists && cyclists.length > 0) {
            this.userExists = true;
            this.cyclists = cyclists;
            this.selectUser(this.cyclists[0]);
          } else {
            this.cyclists = [];
          }
        });
    } else {
      this.cyclists = [];
    }
  }

  searchPhone(event) {
    if (this.UserForm.controls['PhoneNumber'].value.length >= 9) {
      this.userExists = false;
      this.cyclistService
        .searchCyclistByPhoneNumber(
          this.partnerId,
          this.UserForm.controls['PhoneNumber'].value,
        )
        .subscribe((cyclists) => {
          if (cyclists && cyclists.length > 0) {
            this.userExists = true;
            this.cyclists = cyclists;
          } else {
            if (this.UserForm.controls['PhoneNumber'].value.length < 9) {
              this.cyclists = [];
            } else {
              this.cyclists = JSON.parse(JSON.stringify(this.cyclists));
            }
          }
        });
    } else {
      if (this.UserForm.controls['PhoneNumber'].value.length < 9) {
        this.cyclists = [];
      } else {
        this.cyclists = JSON.parse(JSON.stringify(this.cyclists));
      }
    }
  }

  checkPhoneNumber(event) {
    if (this.user && this.user.ID === undefined) {
      this.cyclistService
        .searchCyclistByPhoneNumber(
          this.partnerId,
          this.UserForm.controls['PhoneNumber'].value,
        )
        .subscribe((cyclists) => {
          if (cyclists && cyclists.length > 0) {
            this.userExists = true;
            this.cyclists = cyclists;
            var userWithInternational = this.cyclists
              .filter((x) => {
                return x.PhoneNumber.indexOf('+') > -1;
              })
              .pop();
            if (userWithInternational) {
              this.selectUser(userWithInternational);
            } else {
              this.selectUser(this.cyclists[0]);
            }
          }
        });
    }
  }

  searchSurname(event) {
    if (
      this.UserForm.controls['Surname'].value.length > 0 &&
      this.user.ID === undefined &&
      !this.UserForm.controls['Email'].value &&
      !this.UserForm.controls['PhoneNumber'].value
    ) {
      this.userExists = false;
      this.cyclistService
        .searchCyclistBySurname(
          this.partnerId,
          this.UserForm.controls['Surname'].value,
        )
        .subscribe((cyclists) => {
          if (cyclists && cyclists.length > 0) {
            this.userExists = true;
            this.cyclists = cyclists;
          } else {
            this.cyclists = [];
          }
        });
    } else {
      this.cyclists = [];
    }
  }

  searchName(event) {
    if (
      this.UserForm.controls['Name'].value.length > 0 &&
      this.user.ID === undefined &&
      !this.UserForm.controls['Email'].value &&
      !this.UserForm.controls['PhoneNumber'].value
    ) {
      this.userExists = false;
      this.cyclistService
        .searchCyclistByName(
          this.partnerId,
          this.UserForm.controls['Name'].value,
        )
        .subscribe((cyclists) => {
          if (cyclists && cyclists.length > 0) {
            this.userExists = true;
            this.cyclists = cyclists;
          } else {
            this.cyclists = [];
          }
        });
    } else {
      this.cyclists = [];
    }
  }*/

  searchEmail(event) {
    if (
      this.UserForm.controls['Email'].value.length > 0 &&
      this.UserForm.controls['Email'].value.indexOf('@') > -1
    ) {
      this.user = {};
      this.cyclistService
        .searchCyclistsV2(
          this.partnerId, 0, 20,
          this.UserForm.controls['Email'].value,
        )
        .subscribe((cyclists) => {
          if (cyclists && cyclists.cyclists.length > 0) {
            this.userExists = true;
            this.cyclists = cyclists.cyclists;
            this.selectUser(this.cyclists[0]);
          } else {
            this.cyclists = [];
          }
        });
    } else {
      this.cyclists = [];
    }
  }

  searchPhone(event) {
    if (this.UserForm.controls['PhoneNumber'].value.length >= 9) {
      this.userExists = false;
      this.cyclistService
        .searchCyclistsV2(
          this.partnerId, 0, 20,
          this.UserForm.controls['PhoneNumber'].value,
        )
        .subscribe((cyclists) => {
          if (cyclists && cyclists.cyclists.length > 0) {
            this.userExists = true;
            this.cyclists = cyclists.cyclists;
          } else {
            if (this.UserForm.controls['PhoneNumber'].value.length < 9) {
              this.cyclists = [];
            } else {
              this.cyclists = JSON.parse(JSON.stringify(this.cyclists));
            }
          }
        },err=>{
          this.cyclists = [];
        });
    } else {
      if (this.UserForm.controls['PhoneNumber'].value.length < 9) {
        this.cyclists = [];
      } else {
        this.cyclists = JSON.parse(JSON.stringify(this.cyclists));
      }
    }
  }

  checkPhoneNumber(event) {
    if (this.user && this.user.ID === undefined) {
      this.cyclistService
        .searchCyclistsV2(
          this.partnerId, 0, 20,
          this.UserForm.controls['PhoneNumber'].value,
        )
        .subscribe((cyclists) => {
          if (cyclists && cyclists.cyclists.length > 0) {
            this.userExists = true;
            this.cyclists = cyclists.cyclists;
            var userWithInternational = this.cyclists
              .filter((x) => {
                return x.PhoneNumber.indexOf('+') > -1;
              })
              .pop();
            console.log(userWithInternational)
            if (userWithInternational) {
              this.selectUser(userWithInternational);
            } else {
              this.selectUser(this.cyclists[0]);
            }
          }
        });
    }
  }

  searchSurname(event) {
    if (
      this.UserForm.controls['Surname'].value.length > 0 &&
      this.user.ID === undefined &&
      !this.UserForm.controls['Email'].value &&
      !this.UserForm.controls['PhoneNumber'].value
    ) {
      this.userExists = false;
      this.cyclistService
        .searchCyclistsV2(
          this.partnerId, 0, 20,
          this.UserForm.controls['Surname'].value,
        )
        .subscribe((cyclists) => {
          if (cyclists && cyclists.cyclists.length > 0) {
            this.userExists = true;
            this.cyclists = cyclists.cyclists;
          } else {
            this.cyclists = [];
          }
        });
    } else {
      this.cyclists = [];
    }
  }

  searchName(event) {
    if (
      this.UserForm.controls['Name'].value.length >= 3 &&
      this.user.ID === undefined &&
      !this.UserForm.controls['Email'].value &&
      !this.UserForm.controls['PhoneNumber'].value
    ) {
      this.userExists = false;
      this.cyclistService
        .searchCyclistsV2(
          this.partnerId, 0, 20,
          this.UserForm.controls['Name'].value,
        )
        .subscribe((cyclists) => {
          if (cyclists && cyclists.cyclists.length > 0) {
            this.userExists = true;
            this.cyclists = cyclists.cyclists;
          } else {
            this.cyclists = [];
          }
        });
    } else {
      this.cyclists = [];
    }
  }


  saveUser(formData) {
    this.createUser(formData);
  }

  createUser(formData) {
    let user = {
      ...formData,
      ...{
        Username: formData.Email ? formData.Email : formData.PhoneNumber,
        Password: this.appConfig.defaultUserPassword(),
        ConfirmPassword: this.appConfig.defaultUserPassword(),
        PartnerID: this.partnerId,
      },
    };
    this.busy = true;
    this.error = false;
    user.PartnerID = this.partnerId;
    this.userService.createCustomer(user).subscribe(
      (newUser) => {
        this.selectUser(newUser.Data);
        this.next();

        //Set the users default unit of measure... need to change the registerUser API so we can pass this there...
        //this.cyclistService.getCyclistById(newUser.ID).subscribe((cyclist) => {
        //  cyclist.UnitsOfMeasureID = this.DefaultUnitOfMeasure;
        //  cyclist.PartnerID = this.partnerId;
        //  cyclist.Name = user.Name;
        //  cyclist.Surname = user.Surname;
        //  cyclist.PhoneNumber = user.PhoneNumber;
        //  cyclist.Email = user.Email;

        //  this.cyclistService.saveCyclistV3(cyclist, this.partnerId).subscribe((user) => { });
        //});
        //this.partnerService
        //  .linkCyclistToPartner(this.partnerId, newUser.ID)
        //  .subscribe(
        //    (linked) => {
        //      this.selectUser(newUser);
        //      this.next();
        //    },
        //    (error) => {
        //      this.busy = false;
        //    },
        //  );
      },
      (error) => {
        this.busy = false;
        this.errorMessage = this.translate.instant(
          'messages.problem_creating_cyclist',
        );
        this.error = true;
        this.confirmationService.confirm({
          message: this.translate.instant('messages.problem_creating_cyclist'),
          acceptLabel: this.translate.instant('general.ok'),
          rejectVisible: false,
        });
      },
    );
  }

  clearForm() {
    this.user = {Email: '', Name: '', Surname: '', PhoneNumber : ''};
    this.cyclists = [];    
    this.busy = false;
    setTimeout(()=>{
      this.reloadControlData();
      this.enableControls();
    },300)    
  }
}
